import SettingsList from './SettingsList';
import CreateSettings from './CreateSettings';
import UpdateSettings from './UpdateSettings';
import React, { useEffect } from 'react';
import './App.css';
import axios from 'axios';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import DataApp from './DataContext';

import SecureHeader from './shared/SecureHeader';
import SecureFooter from './shared/SecureFooter';
import SecureLeftPanel from './shared/SecureLeftPanel';

import CareersList from './CareersList';
import CareerUpdate from './CareerUpdate';


import ContactList from './ContactList';
import ContactUpdate from './ContactUpdate';


import SecureRightPanel from './shared/SecureRightPanel';
import Dashboard from './components/Dashboard';
import ImagesList from './components/ImagesList';
import Login from './shared/Login';
import ForgotPassword from './shared/ForgotPassword';
import ResetPassword from './shared/ResetPassword';

import CategoryList from './CategoryList';
import CategoryAdd from './CategoryAdd';
import CategoryDelete from './CategoryDelete'
import CategoryUpdate from './CategoryUpdate'
import PostContentShowAll from './PostContentShowAll';
import UpdatePostContent from './UpdatePostContent';
import CreatePostContent from './CreatePostContent';

import PagesCrud from './PagesCrud';
import CreatePage from './CreatePage';
import UpdatePage from './UpdatePage';

import PageContentShowAll from './PageContentShowAll';
import UpdatePageContent from './UpdatePageContent';
import CreatePageContent from './CreatePageContent';

import BlogList from './components/Blog/BlogList';
import CreateBlog from './components/Blog/CreateBlog';
import UpdateBlog from './components/Blog/UpdateBlog';
import ViewBlog from './components/Blog/ViewBlog';
import PortfolioList from './PortfolioList';
import PortfolioUpdate from './PortfolioUpdate';
import CreatePortfolio from './CreatePortfolio';

import TestimonialsList from './TestimonialsList';
import TestimonialUpdate from './TestimonialUpdate'
import CreateTestimonials from './CreateTestimonials';
import PlacedCandidatesList from './PlacedCandidatesList';
import CreatePlacement from './CreatePlacement';
import PlacementUpdate from "./PlacementUpdate";

import UsersList from "./UsersList";
import AddUser from "./AddUser";
import EditUser from "./EditUser";


function App() {
      /*
          //temp code to keep server live
          const callApiQsList = async () => {
            try {
              const headers = {
                'x-access-token': localStorage.getItem('jwttoken')
              };

              const url = process.env.REACT_APP_API_URL + 'blog/recentblogs';
              await axios.get(url, { headers });
            }
            catch (error) { console.log(error); }
          }
          useEffect(() => {
            setInterval(() => callApiQsList(), 10000)
          }, [])
          //temp code to keep server live
      */



  return (
    <>
      <div className='container-fluid'>
        <BrowserRouter>

          <DataApp>
            <>
              <SecureHeader />
              <div className='row maincontent'>
                <SecureLeftPanel />
                <div className='col bg-light scrollContent border-end border-start px-4 py-4'>
                  <Routes>
                    <Route path='/' element={<Dashboard />} />
                    <Route path='/home' element={<Dashboard />} />
                    <Route path='/dashboard' element={<Dashboard />} />

                    <Route path='/career' element={<CareersList />} />
                    <Route path='/careerupdate/:srno' element={<CareerUpdate />} />

                    <Route path='/contact' element={<ContactList />} />
                    <Route path='/contactupdate/:srno' element={<ContactUpdate />} />

                    <Route path='/categorylist' element={<CategoryList />} />
                    <Route path='/categoryupdate/:srno' element={<CategoryUpdate />} />
                    <Route path='/deleteId/:srno' element={<CategoryDelete />} />
                    <Route path='/addueserid' element={<CategoryAdd />} />

                    <Route path='/postlist' element={<PostContentShowAll />} />
                    <Route path='/postupdate/:srno' element={<UpdatePostContent />} />
                    <Route path='/createpost' element={<CreatePostContent />} />

                    <Route path='/pagecontentlist' element={<PageContentShowAll />} />
                    <Route path='/pagecontentupdate/:srno' element={<UpdatePageContent />} />
                    <Route path='/createpagecontent' element={<CreatePageContent />} />

                    <Route path='/login' element={<Login />} />
                    <Route path='/forgot-password' element={<ForgotPassword />} />
                    <Route path='/reset-password' element={<ResetPassword />} />

                    <Route path='/pages' element={<PagesCrud />} />
                    <Route path='/createpage' element={<CreatePage />} />
                    <Route path='/updatepage/:srno' element={<UpdatePage />} />

                    <Route path='/blogslist' element={<BlogList />} />
                    <Route path='/blogcreate' element={<CreateBlog />} />
                    <Route path='/blogupdate/:blogid' element={<UpdateBlog />} />
                    <Route path='/blogview/:blogid' element={<ViewBlog />} />

                    <Route path='/portfoliolist' element={<PortfolioList />} />
                    <Route path='/portfolioUpdate/:portfolio_id' element={<PortfolioUpdate />} />
                    <Route path='/createPortfolio' element={<CreatePortfolio />} />

                    <Route path='/testimonialslist' element={<TestimonialsList />} />
                    <Route path='/testimonialUpdate/:testimonialid' element={<TestimonialUpdate />} />
                    <Route path='/createTestimonials' element={<CreateTestimonials />} />
                    <Route path="/placedCandidates" element={<PlacedCandidatesList />} />
                    <Route path="/createPlacement" element={<CreatePlacement />} />
                    <Route path="/placementUpdate/:id" element={<PlacementUpdate />} />

                    <Route path="/users" element={<UsersList />} />
                    <Route path="/addUser" element={<AddUser />} />
                    <Route path="/editUser/:id" element={<EditUser />} />
                    
                    <Route path='/imageslist' element={<ImagesList />} />
                    <Route path='/settingslist' element={<SettingsList />} />
                    <Route path='/createSetting' element={<CreateSettings />} />
                    <Route path='/settingUpdate/:id' element={<UpdateSettings />} />
                  </Routes>
                </div>

                <SecureRightPanel />
              </div>
              <SecureFooter />
            </>
          </DataApp>
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;
